// extracted by mini-css-extract-plugin
export var actionButton = "_dr-0";
export var attachmentLine = "_dr-1";
export var fileInput = "_dr-2";
export var fileUploadWrapper = "_dr-4";
export var footer = "_dr-3";
export var modalContent = "_dr-5";
export var paperclip = "_dr-6";
export var quillEditor = "_dr-7";